import { StatusBoardApi } from 'kiolyn-api';
import IStatusBoardRepository from '../domain/repositories/IStatusBoardRepository';

export default class StatusBoardRepository implements IStatusBoardRepository {
  private readonly api: StatusBoardApi;

  constructor(basePath: string) {
    this.api = new StatusBoardApi({ basePath });
  }

  public async getSpeechForReadyOrder(
    storeid: string,
    orderNo: number
  ): Promise<ArrayBufferLike> {
    const cachedData = localStorage.getItem(`speech_order${orderNo}`);
    if (cachedData !== null) {
      return JSON.parse(cachedData);
    }

    const result = await this.api.getSpeechForReadyOrder(storeid, orderNo);
    localStorage.setItem(`speech_order${orderNo}`, JSON.stringify(result.data));
    return result.data;
  }
}
